<div class="popover" [nbSpinner]="loading()">
  <img *ngIf="picture() as pic; else noProfilePicture" [src]="pic" alt="Profile Picture">
  <ng-template #noProfilePicture>
    <div class="picture-placeholder">
      <nb-icon icon="cubes" pack="fas"></nb-icon>
    </div>
  </ng-template>
  <div class="description">
    <div class="title">
      {{tgaType?.name}}
    </div>
    <div class="subtitle">{{tgaType?.tenant?.name}}</div>
    <div class="subtitle">{{tgaType?.description}}</div>
  </div>
  <button nbButton size="small" (click)="navigateToDetail()" *ngIf="!disableLink">
    <nb-icon icon="external-link" pack="eva"></nb-icon>
  </button>
</div>

